<style lang="less" scoped>
@baseFontSize: 1vh;
.check-box{
  .qrcode{
    padding-top: @baseFontSize*40/14;
    margin: auto;
  }
  .check-form{
    padding: @baseFontSize*40/14 @baseFontSize*40/7!important;
    // .el-form-item{
    //   margin-bottom: @baseFontSize*40/15!important;
    // }
  }
}
</style>

<template>
  <div class="check-box">
    <div class="qrcode" :style="{width: qrcodeHeight + 'px'}">
      <qrcode-vue :value="qrcodeUrl" :size="qrcodeHeight" v-loading="loading" ></qrcode-vue>
    </div>
    <el-form class="check-form">
      <el-form-item label="验证码" style="margin-bottom:  2.6666vh!important">
        <el-input v-model="code"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="directSupport" @click="$router.push('/1vs1/detect')" style="flex:2; color: white;">直接使用</el-button>
        <el-button type="primary" @click="checkCode">确定</el-button>

      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import QrcodeVue from 'qrcode.vue';
  import config from '../config';

  export default {
    components: {
      QrcodeVue,
    },
    props: {
      checkOk: Function
    },
    data() {
      return{
        qrcodeUrl: '',
        loading: false,
        code: '',
        result: false,
        rightCode: ''
      }
    },
    computed: {
      qrcodeHeight() {
        return document.body.offsetHeight/ 100 * 40 / 7 * 3
      },
      directSupport(){
        return config.direct_support
      }
    },
    methods: {
      async check(){
        try{
          let res = await this.$request(this.$api.license.check())
          if(res.result){
            this.checkOk()
          }else{
            this.loadQrcode()
          }
        }catch(error){
          this.$message.warning(error.response.data)
        }
      },
      async loadQrcode(){
        this.loading = true
        let res = await this.$request(this.$api.license.qrcode())
        this.rightCode = res.newCode
        this.qrcodeUrl = res.qrcode
        this.loading = false
      },
      async checkCode(){
        if(!this.code){
          this.$message.warning('请先输入验证码')
          return
        }
        try{
          let res = await this.$request(this.$api.license.match(this.code))
          this.$message.success('验证通过，请登录')
          this.checkOk()
        }catch(error){
          this.$message.error(error.response.data.msg)
        }
      }
    },
    mounted(){
      this.check()
    }
  }
</script>